<span class="gc-contact-display-name gc-text-bold" [title]="contact | gcContactDisplayName">
  {{contact | gcContactDisplayName}}
</span>
